import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';

const API = '/api';

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const type = (params.get('type') ?? 'crm') as 'crm' | 'site';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    setError('');
    if (password.length < 6) { setError('Минимум 6 символов'); return; }
    if (password !== confirm) { setError('Пароли не совпадают'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, type, password });
      setDone(true);
    } catch (e: any) {
      setError(e.response?.data?.message || 'Ошибка. Ссылка могла устареть.');
    } finally { setLoading(false); }
  };

  return (
    <div className="login-wrapper">
      <div className="login-box">
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 34, marginBottom: 6 }}>🔑</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: '#818cf8' }}>Keyoff CRM</div>
        </div>

        {!done ? (
          <>
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <div style={{ fontSize: 26, marginBottom: 6 }}>🔒</div>
              <div style={{ fontSize: 15, fontWeight: 600, color: '#f9fafb' }}>Новый пароль</div>
              <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>Введите новый пароль для вашего аккаунта</div>
            </div>
            <input className="input" type="password" placeholder="Новый пароль (мин. 6 символов)"
              value={password} onChange={e => setPassword(e.target.value)}
              style={{ fontSize: 14, padding: '12px 14px', marginBottom: 10 }} />
            <input className="input" type="password" placeholder="Повторите пароль"
              value={confirm} onChange={e => setConfirm(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSubmit()}
              style={{ fontSize: 14, padding: '12px 14px' }} />
            {error && <div className="error" style={{ marginTop: 8 }}>{error}</div>}
            <button className="btn" onClick={handleSubmit} disabled={loading}
              style={{ marginTop: 14, padding: 12, fontSize: 14 }}>
              {loading ? 'Сохранение...' : 'Сохранить пароль'}
            </button>
          </>
        ) : (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
            <div style={{ fontSize: 15, fontWeight: 600, color: '#f9fafb', marginBottom: 8 }}>Пароль изменён!</div>
            <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 20 }}>Теперь вы можете войти с новым паролем.</div>
            <button className="btn" onClick={() => navigate('/')} style={{ padding: 12, fontSize: 14 }}>
              Войти
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
